export interface NavigationItem {
  key: string;
  label: string;
  icon?: string;
  to?: string;
  permission?: string;
  children?: NavigationItem[] | undefined;
}

export const navigation: NavigationItem[] = [
  { key: 'dashboard', label: '仪表盘', icon: '📊', to: '/dashboard', permission: 'menu.dashboard' },
  { key: 'warehouse_overview', label: '仓点总览', icon: '🏬', to: '/warehouse-overview', permission: 'menu.warehouse_overview' },
  {
    key: 'stock', label: '库存数据', icon: '📦', permission: 'menu.stock', children: [
      { key: 'transit', label: '在途库存', to: '/inventory/transit', permission: 'menu.transit' },
      { key: 'inventory', label: '在库库存', to: '/inventory', permission: 'menu.inventory' },
      { key: 'age', label: '库龄明细', to: '/inventory/age', permission: 'menu.age' },
    ],
  },
  {
    key: 'factory', label: '工厂数据', icon: '🏭', permission: 'menu.factory', children: [
      { key: 'factory-orders', label: '工厂订单', to: '/inventory/factory-orders', permission: 'menu.factory_orders' },
      { key: 'factory-shippable', label: '可出货数量', to: '/inventory/factory-shippable', permission: 'menu.factory_shippable' },
    ],
  },
  {
    key: 'sales_group', label: '销量情况', icon: '📈', permission: 'menu.sales_group', children: [
      { key: 'sales', label: '销量数据', to: '/sales', permission: 'menu.sales' },
      { key: 'sales_analysis', label: '销量分析', to: '/sales/analysis', permission: 'menu.sales_analysis' },
    ],
  },
  // 备货分析 = 备货计划页（不再有子菜单；原先挂在它下面的绑定组/占比页已移入「主数据管理」）
  { key: 'analysis', label: '备货分析', icon: '🔍', to: '/replenishment', permission: 'menu.replenishment' },
  // 1.1.85: 「我的权限」—— 普通用户也能访问，故**不放任何 permission**（导航过滤逻辑里
  //   无 permission 的项对所有人可见）。放在备货分析之后、主数据管理之前，与业务入口隔开。
  { key: 'my_permissions', label: '我的权限', icon: '🪪', to: '/my-permissions' },
  {
    key: 'master', label: '主数据管理', icon: '🛠', permission: 'menu.master', children: [
      { key: 'warehouses', label: '仓库管理', to: '/warehouses', permission: 'menu.warehouses' },
      { key: 'skus', label: 'SKU 管理', to: '/skus', permission: 'menu.skus' },
      { key: 'sku-groups', label: 'SKU 绑定组', to: '/sku-groups', permission: 'menu.sku_groups' },
      { key: 'warehouse-analysis-master', label: '仓发占比分析', to: '/warehouse-analysis', permission: 'menu.warehouse_analysis' },
      { key: 'ratios-master', label: '尾程各仓发货占比', to: '/ratios', permission: 'menu.ratios' },
      { key: 'activities', label: '活动配置', to: '/activities', permission: 'menu.activities' },
    ],
  },
  {
    key: 'settings', label: '设置', icon: '⚙', permission: 'menu.settings', children: [
      { key: 'permissions', label: '权限管理', to: '/permissions', permission: 'menu.permissions' },
      { key: 'users', label: '用户管理', to: '/users', permission: 'menu.users' },
      { key: 'audit', label: '审计日志', to: '/audit', permission: 'menu.audit' },
      { key: 'help', label: '📖 使用帮助', to: '/help', permission: 'menu.help' },
    ],
  },
];
